// Pooled inbox SP3 (R129): which web page each onboarding stage key means.
// Keys are the server's ONBOARDING_STAGES keys; there is deliberately no
// order here — the order lives only in the server's list, and pages learn
// ahead/behind from the `stages` array GET /onboarding/stage serves. A stage
// that is not a key here (plan and later until SP5) means "apply the legacy
// landing rule". SP4: trial_start lands on You're in; intake lands on the
// dashboard — nobody at intake is sent into the wizard by a landing
// (decision 4); only the dashboard's pass opens it.
export const ONBOARDING_ROUTES = {
  signup_pending_verification: "/verify-code",
  documents_acknowledge: "/onboarding/acknowledge",
  documents_agreement: "/onboarding/agreement",
  documents_consents: "/onboarding/consents",
  documents_receipt: "/onboarding/done",
  trial_start: "/welcome",
  intake: "/dashboard",
};

export function onboardingRouteFor(stage) {
  return Object.prototype.hasOwnProperty.call(ONBOARDING_ROUTES, stage)
    ? ONBOARDING_ROUTES[stage]
    : null;
}
